import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

export interface kpiDefinitionIdsRequest {
  hierarchyId: string
  kpiDefinitionIds: string[]
  from: string
  to: string
}

export const ZStandardandCustomParamterDetails = z.object({
  kpi_definition_id: z.string(),
  timestamp: z.string(),
  tenant_id: z.string(),
  asset_id: z.string(),
  is_custom_kpi: z.boolean(),
  kpi_value: z.number().optional(),
  units: z.string().optional(),
  kpi_name: z.string()
})

export const ZData = z.object({
  totalCount: z.number(),
  content: ZStandardandCustomParamterDetails.array()
})

export const ZApiResponse = z.object({
  http_status: z.number(),
  error: z.boolean(),
  data: z.optional(ZData)
})

export type StandardandCustomParamterDetails = z.infer<typeof ZStandardandCustomParamterDetails>
export type StandardandCustomParamterAPIData = z.infer<typeof ZApiResponse>

export async function getStandardandCustomParamter (
  page: number,
  size: number,
  pagination: boolean,
  latest: boolean,
  kpiDefinitionIds: kpiDefinitionIdsRequest,
  onSuccess: (StandardandCustomParamterDetailsData: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const url = `/kpirest/api/v1/udp/tiq/kpi/kpiValues?page=${page}&size=${size}&pagination=${pagination}&latest=${latest}`
  interceptedAxios
    .post(url, kpiDefinitionIds, { timeout: 10000 })
    .then((response) => {
      if (response.status === 200) {
        const parseResponse = ZApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          if (response.data.data !== null && response.data.data !== undefined) {
            onSuccess(parseResponse.data.data, response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
